import { CashFlowItemService } from "./../../../services/catalogs/CashFlowItemService";
import { CashFlowItemDetail } from "./../../../components/Pages/Catalogs/cashflowitem/CashflowItemDetail";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateCashflowItemDto } from "../../../dtos/catalogs/cashflowitem/CreateCashflowItemDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCashflowItem } from "../../../components/Shared/NewForms/NFLookupCashflowItem";
import CashflowItemList from "../../../components/Pages/Catalogs/cashflowitem/CashflowItemList";
import { CashboxesDetail } from "../../../components/Pages/Catalogs/Cashboxes/CashboxesDetail";
import CashboxesList from "../../../components/Pages/Catalogs/Cashboxes/CashboxesList";
import { NFLookupCashboxes } from "../../../components/Shared/NewForms/NFLookupCashboxes";
import { CashboxesService } from "../../../services/catalogs/CashboxesService";
import { CreateCashboxesDto } from "../../../dtos/catalogs/Cashboxes/CreateCashboxesDto";

export const CompanyCashBox: IAppEntity = {
  entityType: "catalog",
  title: "CashBoxes",
  pluralTitle: "CashBoxes",
  apiUrl: "CashBoxes",
  apiEnum: ReferenceTypes.CatalogCompanyCashBox,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(CashboxesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashboxesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCashboxes, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new CashboxesService(this.apiUrl);
  },
  getEmptyModel(): CreateCashboxesDto {
    return {
      name: "",
    };
  },
};
